// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Js_math = require("rescript/lib/js/js_math.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Pervasives = require("rescript/lib/js/pervasives.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Selector$SmartcutsMacros = require("../Selector.bs.js");
var InputLabel$SmartcutsMacros = require("./shared/InputLabel.bs.js");
var OptionUtils$SmartcutsMacros = require("../../../bs-utils/src/OptionUtils.bs.js");
var DOM__Element$SmartcutsMacros = require("../DOM__Element.bs.js");
var DataDependency$SmartcutsMacros = require("./shared/DataDependency.bs.js");
var DOM__FileInputElement$SmartcutsMacros = require("../DOM__FileInputElement.bs.js");

var fakePath = "C:\\fakepath\\";

function fileInputElement_encode(v) {
  return Js_dict.fromArray([
              [
                "selector",
                Selector$SmartcutsMacros.selector_encode(v.selector)
              ],
              [
                "accept",
                Decco.optionToJson(Decco.stringToJson, v.accept)
              ],
              [
                "isVisibleOnPage",
                Decco.boolToJson(v.isVisibleOnPage)
              ]
            ]);
}

function fileUpload_encode(encoder_fileInfo, v) {
  return [
          "SingleFile",
          Curry._1(encoder_fileInfo, v._0)
        ];
}

function fileInputElement_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var selector = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selector"), null));
  if (selector.TAG === /* Ok */0) {
    var accept = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "accept"), null));
    if (accept.TAG === /* Ok */0) {
      var isVisibleOnPage = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "isVisibleOnPage"), null));
      if (isVisibleOnPage.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  selector: selector._0,
                  accept: accept._0,
                  isVisibleOnPage: isVisibleOnPage._0
                }
              };
      }
      var e = isVisibleOnPage._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".isVisibleOnPage" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = accept._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".accept" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = selector._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".selector" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function fileUpload_decode(decoder_fileInfo, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "SingleFile") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = Curry._1(decoder_fileInfo, Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* SingleFile */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function t_encode(encoder_fileInfo, encoder_inputLabel, v) {
  return Js_dict.fromArray([
              [
                "fileUpload",
                fileUpload_encode(encoder_fileInfo, v.fileUpload)
              ],
              [
                "fileInputElement",
                fileInputElement_encode(v.fileInputElement)
              ],
              [
                "label",
                Decco.optionToJson(encoder_inputLabel, v.label)
              ]
            ]);
}

function t_decode(decoder_fileInfo, decoder_inputLabel, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var fileUpload = fileUpload_decode(decoder_fileInfo, Belt_Option.getWithDefault(Js_dict.get(dict$1, "fileUpload"), null));
  if (fileUpload.TAG === /* Ok */0) {
    var fileInputElement = fileInputElement_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "fileInputElement"), null));
    if (fileInputElement.TAG === /* Ok */0) {
      var label = Decco.optionFromJson(decoder_inputLabel, Belt_Option.getWithDefault(Js_dict.get(dict$1, "label"), null));
      if (label.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  fileUpload: fileUpload._0,
                  fileInputElement: fileInputElement._0,
                  label: label._0
                }
              };
      }
      var e = label._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".label" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = fileInputElement._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".fileInputElement" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = fileUpload._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".fileUpload" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function stringifyFileInpuElement(param) {
  return "{ selector: " + (Selector$SmartcutsMacros.stringify(undefined, false, param.selector) + (", accept: " + (OptionUtils$SmartcutsMacros.stringify((function (x) {
                      return x;
                    }), param.accept) + (", isVisibleOnPage: " + (Pervasives.string_of_bool(param.isVisibleOnPage) + " }")))));
}

function stringify(stringifyFileInfo, stringifyLabel, param) {
  return "{ fileUpload: " + ("SingleFile(" + (Curry._1(stringifyFileInfo, param.fileUpload._0) + ")") + (", fileInputElement: " + (stringifyFileInpuElement(param.fileInputElement) + (", label: " + (OptionUtils$SmartcutsMacros.stringify(stringifyLabel, param.label) + " }")))));
}

var Generic = {
  t_encode: t_encode,
  t_decode: t_decode,
  fileInputElement_encode: fileInputElement_encode,
  fileInputElement_decode: fileInputElement_decode,
  fileUpload_encode: fileUpload_encode,
  fileUpload_decode: fileUpload_decode,
  stringifyFileInpuElement: stringifyFileInpuElement,
  stringify: stringify
};

function fileInfo_encode(v) {
  return Js_dict.fromArray([
              [
                "originalFileName",
                Decco.stringToJson(v.originalFileName)
              ],
              [
                "originalFileType",
                Decco.stringToJson(v.originalFileType)
              ]
            ]);
}

function fileInfo_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var originalFileName = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "originalFileName"), null));
  if (originalFileName.TAG === /* Ok */0) {
    var originalFileType = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "originalFileType"), null));
    if (originalFileType.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                originalFileName: originalFileName._0,
                originalFileType: originalFileType._0
              }
            };
    }
    var e = originalFileType._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".originalFileType" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = originalFileName._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".originalFileName" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function t_encode$1(v) {
  return t_encode(fileInfo_encode, InputLabel$SmartcutsMacros.RecordingAndAuthoring.t_encode, v);
}

function t_decode$1(v) {
  return t_decode(fileInfo_decode, InputLabel$SmartcutsMacros.RecordingAndAuthoring.t_decode, v);
}

function stringifyFileInfo(param) {
  return "{ originalFileName: " + (param.originalFileName + (", originalFileType: " + (param.originalFileType + " }")));
}

function stringify$1(param) {
  return stringify(stringifyFileInfo, InputLabel$SmartcutsMacros.RecordingAndAuthoring.stringify, param);
}

function fromFileAndInputElment(file, inputElement) {
  var selector = Selector$SmartcutsMacros.forDomElement(inputElement);
  var arg = DOM__FileInputElement$SmartcutsMacros.ofElement(inputElement);
  var fileInputElement = (function (param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg);
      })("Expect to get file input from element");
  var partial_arg = /_+/g;
  var partial_arg$1 = function (param) {
    return param.replace(partial_arg, " ");
  };
  var label = OptionUtils$SmartcutsMacros.map(InputLabel$SmartcutsMacros.RecordingAndAuthoring.forHtmlInputElement(inputElement), (function (param) {
          return InputLabel$SmartcutsMacros.RecordingAndAuthoring.mapAllLabelTexts(partial_arg$1, param);
        }));
  var accept = fileInputElement.accept;
  var accept$1 = accept === "" ? undefined : accept;
  var isVisibleOnPage = false;
  if (DOM__Element$SmartcutsMacros.isVisibleInViewport(inputElement)) {
    var match = DOM__Element$SmartcutsMacros.getClientXAndClientYOfCenterOfElement(inputElement);
    isVisibleOnPage = Caml_obj.caml_equal(Caml_option.nullable_to_opt(document.elementFromPoint(Js_math.floor(match[0]), Js_math.floor(match[1]))), Caml_option.some(inputElement));
  }
  return {
          fileUpload: /* SingleFile */{
            _0: {
              originalFileName: file.name,
              originalFileType: file.type
            }
          },
          fileInputElement: {
            selector: selector,
            accept: accept$1,
            isVisibleOnPage: isVisibleOnPage
          },
          label: label
        };
}

function fromInputEvent(inputEvent) {
  var target = inputEvent.target;
  var arg = DOM__FileInputElement$SmartcutsMacros.ofElement(target);
  var fileInputElement = (function (param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg);
      })("Expect to get file input from element");
  var arg$1 = fileInputElement.files.item(0);
  var file = (function (param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
      })("Expect to get first file from file input");
  return fromFileAndInputElment(file, target);
}

var Recording = {
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  fileInfo_encode: fileInfo_encode,
  fileInfo_decode: fileInfo_decode,
  stringifyFileInfo: stringifyFileInfo,
  stringify: stringify$1,
  fromFileAndInputElment: fromFileAndInputElment,
  fromInputEvent: fromInputEvent
};

function t_encode$2(v) {
  return t_encode(fileInfo_encode, InputLabel$SmartcutsMacros.RecordingAndAuthoring.t_encode, v);
}

function t_decode$2(v) {
  return t_decode(fileInfo_decode, InputLabel$SmartcutsMacros.RecordingAndAuthoring.t_decode, v);
}

function stringify$2(param) {
  return stringify(stringifyFileInfo, InputLabel$SmartcutsMacros.RecordingAndAuthoring.stringify, param);
}

function fromRecordingCommandValue(param) {
  return {
          fileUpload: param.fileUpload,
          fileInputElement: param.fileInputElement,
          label: param.label
        };
}

function getIdentifier(param) {
  return Selector$SmartcutsMacros.stringify(undefined, false, param.fileInputElement.selector);
}

var Authoring = {
  t_encode: t_encode$2,
  t_decode: t_decode$2,
  stringify: stringify$2,
  fromRecordingCommandValue: fromRecordingCommandValue,
  getIdentifier: getIdentifier
};

function fileObject_encode(v) {
  return Js_dict.fromArray([
              [
                "objectUrl",
                Decco.stringToJson(v.objectUrl)
              ],
              [
                "fileName",
                Curry._1(DataDependency$SmartcutsMacros.DataRef.t_encode, v.fileName)
              ]
            ]);
}

function fileObject_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var objectUrl = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "objectUrl"), null));
  if (objectUrl.TAG === /* Ok */0) {
    var fileName = Curry._1(DataDependency$SmartcutsMacros.DataRef.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "fileName"), null));
    if (fileName.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                objectUrl: objectUrl._0,
                fileName: fileName._0
              }
            };
    }
    var e = fileName._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".fileName" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = objectUrl._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".objectUrl" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function fileInfo_decode$1(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "FileObject" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = fileObject_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* FileObject */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "FileReference" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Curry._1(DataDependency$SmartcutsMacros.DataRef.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* FileReference */1,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function fileInfo_encode$1(v) {
  if (v.TAG === /* FileObject */0) {
    return [
            "FileObject",
            fileObject_encode(v._0)
          ];
  } else {
    return [
            "FileReference",
            Curry._1(DataDependency$SmartcutsMacros.DataRef.t_encode, v._0)
          ];
  }
}

function t_encode$3(v) {
  return t_encode(fileInfo_encode$1, InputLabel$SmartcutsMacros.t_encode, v);
}

function t_decode$3(v) {
  return t_decode(fileInfo_decode$1, InputLabel$SmartcutsMacros.t_decode, v);
}

function stringifyFileInfo$1(fileInfo) {
  if (fileInfo.TAG === /* FileObject */0) {
    return "FileObject(" + (Curry._1(DataDependency$SmartcutsMacros.DataRef.stringify, fileInfo._0.fileName) + ")");
  } else {
    return "FileReference(" + (Curry._1(DataDependency$SmartcutsMacros.DataRef.stringify, fileInfo._0) + ")");
  }
}

function stringify$3(param) {
  return stringify(stringifyFileInfo$1, InputLabel$SmartcutsMacros.stringify, param);
}

function fromAuthoringCommandValue(param) {
  var fileUpload$p = /* SingleFile */{
    _0: {
      TAG: /* FileReference */1,
      _0: {
        TAG: /* StaticText */0,
        _0: fakePath + param.fileUpload._0.originalFileName
      }
    }
  };
  return {
          fileUpload: fileUpload$p,
          fileInputElement: param.fileInputElement,
          label: Belt_Option.map(param.label, InputLabel$SmartcutsMacros.fromRecordingAndAuthoring)
        };
}

var Playback = {
  t_encode: t_encode$3,
  t_decode: t_decode$3,
  fileInfo_encode: fileInfo_encode$1,
  fileInfo_decode: fileInfo_decode$1,
  fileObject_encode: fileObject_encode,
  fileObject_decode: fileObject_decode,
  stringifyFileInfo: stringifyFileInfo$1,
  stringify: stringify$3,
  fromAuthoringCommandValue: fromAuthoringCommandValue
};

function selectorGet(param) {
  return [param.fileInputElement.selector];
}

function mapSelector(f, commandValue) {
  var fileInputElement = commandValue.fileInputElement;
  return {
          fileUpload: commandValue.fileUpload,
          fileInputElement: {
            selector: Curry._1(f, fileInputElement.selector),
            accept: fileInputElement.accept,
            isVisibleOnPage: fileInputElement.isVisibleOnPage
          },
          label: commandValue.label
        };
}

var CommandValue = {
  Generic: Generic,
  Recording: Recording,
  Authoring: Authoring,
  Playback: Playback,
  selectorGet: selectorGet,
  mapSelector: mapSelector
};

function updateConfigWithPlaybackFormLabel(config, playbackFormLabel) {
  return {
          originalFileName: config.originalFileName,
          label: config.label,
          selectedLabelIndex: config.selectedLabelIndex,
          playbackFormLabel: playbackFormLabel,
          accept: config.accept
        };
}

function isDynamic(param) {
  return true;
}

function mapDataRef(config, param) {
  return config;
}

function fromCommandValue(param) {
  var label = param.label;
  var arg = Belt_Option.flatMap(label, InputLabel$SmartcutsMacros.RecordingAndAuthoring.getLabelText);
  return {
          originalFileName: param.fileUpload._0.originalFileName,
          label: label,
          selectedLabelIndex: undefined,
          playbackFormLabel: (function (param) {
                return OptionUtils$SmartcutsMacros.withDefault(param, arg);
              })("[Add a label]"),
          accept: param.fileInputElement.accept
        };
}

var AuthoringConfig = {
  updateConfigWithPlaybackFormLabel: updateConfigWithPlaybackFormLabel,
  isDynamic: isDynamic,
  mapDataRef: mapDataRef,
  fromCommandValue: fromCommandValue
};

function t_encode$4(v) {
  return Js_dict.fromArray([
              [
                "playbackFormLabel",
                Decco.stringToJson(v.playbackFormLabel)
              ],
              [
                "accept",
                Decco.optionToJson(Decco.stringToJson, v.accept)
              ],
              [
                "fullPath",
                Curry._1(DataDependency$SmartcutsMacros.DataRef.t_encode, v.fullPath)
              ]
            ]);
}

function t_decode$4(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var playbackFormLabel = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "playbackFormLabel"), null));
  if (playbackFormLabel.TAG === /* Ok */0) {
    var accept = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "accept"), null));
    if (accept.TAG === /* Ok */0) {
      var fullPath = Curry._1(DataDependency$SmartcutsMacros.DataRef.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "fullPath"), null));
      if (fullPath.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  playbackFormLabel: playbackFormLabel._0,
                  accept: accept._0,
                  fullPath: fullPath._0
                }
              };
      }
      var e = fullPath._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".fullPath" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = accept._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".accept" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = playbackFormLabel._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".playbackFormLabel" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function fromAuthoringConfig(param) {
  return {
          playbackFormLabel: param.playbackFormLabel,
          accept: param.accept,
          fullPath: {
            TAG: /* StaticText */0,
            _0: fakePath + param.originalFileName
          }
        };
}

function getPlaybackFormLabelFromParam(param) {
  return param.playbackFormLabel;
}

var ParamDescriptor = {
  t_encode: t_encode$4,
  t_decode: t_decode$4,
  fromAuthoringConfig: fromAuthoringConfig,
  getPlaybackFormLabelFromParam: getPlaybackFormLabelFromParam
};

var t_encode$5 = fileInfo_encode$1;

var t_decode$5 = fileInfo_decode$1;

function fromParamDescriptor(param) {
  return {
          TAG: /* FileReference */1,
          _0: param.fullPath
        };
}

function toPlaybackCommandValue(oldCommandValue, fileInfo) {
  return {
          fileUpload: /* SingleFile */{
            _0: fileInfo
          },
          fileInputElement: oldCommandValue.fileInputElement,
          label: oldCommandValue.label
        };
}

var stringify$4 = stringifyFileInfo$1;

function hasUserSetTheFileReference(dataRef) {
  return !Curry._1(DataDependency$SmartcutsMacros.DataRef.resolveAsText, dataRef).startsWith(fakePath);
}

var PlaybackParamValue = {
  t_encode: t_encode$5,
  t_decode: t_decode$5,
  fromParamDescriptor: fromParamDescriptor,
  toPlaybackCommandValue: toPlaybackCommandValue,
  stringify: stringify$4,
  hasUserSetTheFileReference: hasUserSetTheFileReference
};

exports.CommandValue = CommandValue;
exports.AuthoringConfig = AuthoringConfig;
exports.ParamDescriptor = ParamDescriptor;
exports.PlaybackParamValue = PlaybackParamValue;
/* Selector-SmartcutsMacros Not a pure module */
